import { createFileRoute } from "@tanstack/react-router";
import { LegalPage, P, UL, H3 } from "@/components/marketing/LegalPage";
import { alternateLinkList } from "@/lib/i18n/locale";

export const Route = createFileRoute("/vi/legal-guidelines")({
  head: () => ({
    meta: [
      { title: "Hướng dẫn Pháp lý — banana.cards" },
      { name: "description", content: "Hướng dẫn Sử dụng Đạo đức và Chính sách Sử dụng Chấp nhận được của Banana Cards." },
      { property: "og:title", content: "Hướng dẫn Pháp lý — banana.cards" },
      { property: "og:description", content: "Cách sử dụng Banana Cards một cách có trách nhiệm, hợp pháp và đạo đức." },
      { property: "og:locale", content: "vi_VN" },
    ],
    links: alternateLinkList("/legal-guidelines", "vi"),
  }),
  component: LegalGuidelinesPageVi,
});

function LegalGuidelinesPageVi() {
  return (
    <LegalPage
      eyebrow="Pháp lý"
      title="Hướng dẫn"
      italic="Pháp lý."
      updated="Tháng 1, 2026"
      intro="Sứ mệnh của chúng tôi là giúp cá nhân, chuyên gia và doanh nghiệp kết nối thông minh hơn thông qua danh thiếp NFC, hồ sơ số, quản lý liên hệ, tự động hóa và công cụ AI. Các hướng dẫn này giải thích cách sử dụng Banana Cards một cách có trách nhiệm, hợp pháp và đạo đức."
      related={[
        { label: "Điều khoản Dịch vụ", to: "/vi/terms" },
        { label: "Chính sách Bảo mật", to: "/vi/privacy" },
        { label: "Liên hệ với chúng tôi", to: "/vi/contact" },
      ]}
      sections={[
        {
          id: "overview",
          title: "Ai vận hành Banana Cards",
          body: (
            <>
              <P>Banana Cards được vận hành toàn cầu bởi Six Studio Creative FZCO cho các dịch vụ phần mềm, nền tảng và công nghệ trên toàn thế giới. Tại Việt Nam, hoạt động thẻ vật lý, phân phối địa phương, hỗ trợ khách hàng và các hoạt động thương mại liên quan được quản lý bởi Banana Cards Vietnam.</P>
              <P>Các Hướng dẫn Sử dụng Đạo đức này bảo vệ người dùng, khách hàng, đối tác và môi trường số rộng lớn, đồng thời đảm bảo nền tảng vẫn an toàn, đáng tin cậy và tuân thủ.</P>
            </>
          ),
        },
        {
          id: "approved",
          title: "Các Trường hợp Sử dụng Được phê duyệt & Khuyến khích",
          body: (
            <>
              <P>Banana Cards được xây dựng để hỗ trợ các hoạt động cá nhân, chuyên nghiệp và kinh doanh hợp pháp.</P>
              <H3>Kết nối Chuyên nghiệp</H3>
              <P>Chia sẻ thông tin liên hệ nhanh chóng và an toàn qua thẻ NFC, mã QR, hồ sơ số và wallet pass.</P>
              <H3>Quản lý Lead Kinh doanh</H3>
              <P>Thu thập, tổ chức, gắn nhãn và quản lý lead hoặc liên hệ thông qua công cụ quản lý liên hệ của Banana Cards.</P>
              <H3>Quy trình CRM và Theo dõi</H3>
              <P>Sử dụng nhắc nhở, ghi chú, nhãn, tác vụ, pipeline và tự động hóa để quản lý mối quan hệ kinh doanh hiệu quả.</P>
              <H3>Hồ sơ Kinh doanh Số</H3>
              <P>Tạo hồ sơ chuyên nghiệp thể hiện thông tin liên hệ, công ty, liên kết, dịch vụ, portfolio và tùy chọn đặt lịch.</P>
              <H3>Tiếp thị và Truyền thông</H3>
              <P>Gửi các thông tin kinh doanh phù hợp đến liên hệ khi người dùng có cơ sở pháp lý, sự đồng ý hoặc mối quan hệ kinh doanh sẵn có.</P>
              <H3>Năng suất Hỗ trợ bởi AI</H3>
              <P>Sử dụng công cụ AI của Banana Cards để soạn tin nhắn, tóm tắt thông tin liên hệ, làm giàu bản ghi, đề xuất theo dõi hoặc hỗ trợ quy trình bán hàng.</P>
              <H3>Trí tuệ Kinh doanh</H3>
              <P>Xem phân tích, dữ liệu tương tác và hoạt động liên hệ để cải thiện chiến lược kết nối, bán hàng và quan hệ khách hàng.</P>
            </>
          ),
        },
        {
          id: "prohibited",
          title: "Hoạt động Bị cấm — Không Khoan nhượng",
          body: (
            <>
              <P>Banana Cards không được sử dụng cho các hoạt động bất hợp pháp, gây hại, lạm dụng, lừa đảo hoặc phi đạo đức. Các hoạt động bị cấm bao gồm nhưng không giới hạn ở:</P>
              <H3>Spam hoặc Nhắn tin Không mong muốn</H3>
              <P>Người dùng không được gửi hàng loạt email, tin nhắn, khuyến mãi hoặc truyền thông tự động mà không có sự đồng ý hợp lệ hoặc cơ sở pháp lý.</P>
              <H3>Gian lận, Lừa đảo hoặc Xuyên tạc</H3>
              <P>Người dùng không được tạo hồ sơ giả, mạo danh người hoặc công ty khác, gây hiểu lầm cho người nhận hoặc dùng Banana Cards để hỗ trợ hoạt động gian lận.</P>
              <H3>Thu thập Dữ liệu Trái phép</H3>
              <P>Người dùng không được thu thập, nhập, cào hoặc lưu trữ dữ liệu cá nhân mà không có sự cho phép, cơ sở pháp lý hoặc thẩm quyền phù hợp.</P>
              <H3>Tài khoản hoặc Hồ sơ Kinh doanh Giả mạo</H3>
              <P>Người dùng không được tạo danh tính giả, hồ sơ công ty giả, thẻ số gây hiểu lầm hoặc mô tả kinh doanh lừa đảo.</P>
              <H3>Tự động hóa Lạm dụng</H3>
              <P>Tính năng tự động hóa không được dùng để quấy rối, thao túng, spam hoặc áp đảo người nhận.</P>
              <H3>Nội dung Bất hợp pháp hoặc Bị hạn chế</H3>
              <P>Người dùng không được dùng Banana Cards để quảng bá, phân phối hoặc tạo điều kiện cho hàng hóa, dịch vụ, nội dung hoặc hoạt động bất hợp pháp.</P>
              <H3>Phishing hoặc Thu thập Thông tin Đăng nhập</H3>
              <P>Người dùng không được dùng hồ sơ, liên kết, biểu mẫu hoặc tin nhắn Banana Cards để lừa người khác tiết lộ mật khẩu, thông tin thanh toán, giấy tờ tùy thân hoặc dữ liệu nhạy cảm khác.</P>
              <H3>Phần mềm Độc hại hoặc Liên kết Nguy hại</H3>
              <P>Người dùng không được thêm liên kết, tệp, script hoặc chuyển hướng chứa phần mềm độc hại, virus, spyware, mã độc hoặc website không an toàn.</P>
              <H3>Quấy rối, Lạm dụng hoặc Phân biệt Đối xử</H3>
              <P>Người dùng không được dùng nền tảng để đe dọa, quấy rối, khủng bố tinh thần, phân biệt đối xử hoặc lạm dụng bất kỳ cá nhân hoặc nhóm nào.</P>
              <H3>Xâm phạm Quyền của Bên thứ ba</H3>
              <P>Người dùng không được tải lên hoặc chia sẻ nội dung xâm phạm bản quyền, thương hiệu, quyền riêng tư, quyền nhân thân hoặc các quyền sở hữu trí tuệ khác.</P>
              <H3>Thao túng Đánh giá hoặc Tương tác</H3>
              <P>Người dùng không được dùng Banana Cards để tạo đánh giá giả, tương tác giả, lời chứng thực gây hiểu lầm hoặc các tín hiệu uy tín kinh doanh bị thao túng.</P>
            </>
          ),
        },
        {
          id: "privacy-consent",
          title: "Quyền riêng tư Dữ liệu và Sự đồng ý",
          body: (
            <>
              <P>Người dùng Banana Cards chịu trách nhiệm đảm bảo mọi dữ liệu cá nhân mà họ tải lên, thu thập, lưu trữ hoặc xử lý qua nền tảng đều được xử lý hợp pháp và có sự đồng ý phù hợp.</P>
              <P>Điều này bao gồm thông tin liên hệ, danh thiếp, thông tin đã quét, liên hệ đã nhập, ghi chú, lịch sử trao đổi và dữ liệu được AI làm giàu.</P>
              <P>Người dùng chỉ được tải lên hoặc xử lý dữ liệu cá nhân khi có quyền làm như vậy. Banana Cards không cho phép việc thu thập, lưu trữ hoặc sử dụng dữ liệu cá nhân có được một cách bất hợp pháp, lừa đảo hoặc không có sự cho phép phù hợp.</P>
            </>
          ),
        },
        {
          id: "ai",
          title: "Sử dụng Tính năng AI",
          body: (
            <>
              <P>Banana Cards có thể bao gồm các tính năng hỗ trợ AI giúp người dùng soạn tin nhắn, tóm tắt thông tin, quét danh thiếp, làm giàu liên hệ, đề xuất theo dõi hoặc tự động hóa các tác vụ quy trình.</P>
              <P>Người dùng vẫn chịu trách nhiệm xem xét và phê duyệt nội dung do AI tạo trước khi sử dụng.</P>
              <P>Công cụ AI không được sử dụng để:</P>
              <UL items={[
                "Tạo truyền thông lừa đảo hoặc gây hiểu lầm",
                "Mạo danh người khác",
                "Gửi spam hoặc tiếp cận trái phép",
                "Tạo hợp đồng, đề xuất hoặc tài liệu gian lận",
                "Xử lý dữ liệu cá nhân nhạy cảm mà không có sự cho phép",
                "Đưa ra các quyết định pháp lý, tài chính, y tế hoặc việc làm có rủi ro cao mà không có sự xem xét phù hợp của con người",
              ]} />
              <P>Đề xuất do AI tạo được cung cấp để hỗ trợ năng suất và không nên được coi là tư vấn pháp lý, tài chính, thuế, y tế hoặc chuyên môn.</P>
            </>
          ),
        },
        {
          id: "enforcement",
          title: "Chặn Nội dung và Giới hạn Dịch vụ",
          body: (
            <>
              <P>Để bảo vệ tính toàn vẹn của nền tảng Banana Cards, Six Studio Creative FZCO và/hoặc Banana Cards Vietnam có thể hạn chế, tạm ngừng, xóa hoặc chặn các tài khoản, hồ sơ, liên kết, nội dung, tự động hóa hoặc hoạt động có vẻ không an toàn, lạm dụng, bất hợp pháp hoặc không tuân thủ.</P>
              <P>Điều này có thể bao gồm nội dung hoặc hoạt động liên quan đến spam, gian lận, phishing, liên kết có hại, mạo danh, thu thập dữ liệu trái phép hoặc vi phạm chính sách lặp lại.</P>
              <P>Chúng tôi cũng có thể giới hạn việc sử dụng khi cần thiết để bảo vệ hiệu suất nền tảng, an toàn người dùng, tuân thủ pháp lý hoặc quyền của bên thứ ba.</P>
            </>
          ),
        },
        {
          id: "user-role",
          title: "Vai trò của bạn trong việc Duy trì Nền tảng An toàn",
          body: (
            <>
              <P>Mỗi người dùng Banana Cards đóng vai trò trong việc giữ cho nền tảng an toàn, đạo đức và đáng tin cậy. Người dùng nên:</P>
              <UL items={[
                "Chia sẻ thông tin chính xác và trung thực",
                "Tôn trọng quyền riêng tư và sự đồng ý",
                "Giao tiếp một cách chuyên nghiệp",
                "Sử dụng tự động hóa có trách nhiệm",
                "Xem xét nội dung do AI tạo trước khi gửi",
                "Báo cáo lạm dụng, hoạt động đáng ngờ hoặc vi phạm chính sách",
              ]} />
              <P>Khi sử dụng Banana Cards, người dùng đồng ý tuân theo các Hướng dẫn Sử dụng Đạo đức này và mọi điều khoản, chính sách bảo mật và luật địa phương áp dụng.</P>
            </>
          ),
        },
        {
          id: "report",
          title: "Báo cáo Lạm dụng",
          body: (
            <>
              <P>Nếu bạn tin rằng ai đó đang lạm dụng Banana Cards — mạo danh người hoặc công ty khác, gửi spam, thu thập dữ liệu không được phép hoặc chia sẻ nội dung có hại — bạn có thể báo cáo vấn đề cho chúng tôi.</P>
              <P>Báo cáo có thể được xem xét bởi Six Studio Creative FZCO cho các vấn đề nền tảng toàn cầu và/hoặc Banana Cards Vietnam cho các vấn đề vận hành tại Việt Nam.</P>
              <P>Gửi email <a href="mailto:hello@banana.cards" className="font-bold underline-offset-4 hover:underline">hello@banana.cards</a> với tiêu đề "Report Misuse / Policy Violation".</P>
            </>
          ),
        },
      ]}
    />
  );
}